//GoToXY.ts ==============================================================
import "../Util/Prototypes";

import * as GraLay from "../Util/GraLay";
import * as MainMap from "../MainMap";
import * as SnackBar from "../Util/SnackBar";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";

//ESRI javascript API.
import Extent from "@arcgis/core/geometry/Extent";
import Graphic from "@arcgis/core/Graphic";
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol";

//Attempt to zoom to the point.
export function zoomToXY(str: string) {
   import("@arcgis/core/widgets/CoordinateConversion/CoordinateConversionViewModel").then(({ default: CoordinateVM }) => {

      const sa: string[] = str.split(",");
      let x = Util.parseFlt(sa[0]);
      let y = Util.parseFlt(sa[1]);

      //Initialize to basemap x,y coordinate system.
      let formatName: string = "basemap";
      let xyStr: string = str;

      //See if lat/long was entered.
      if ((x > 20 && x < 60) || (y > 20 && y < 60)) {
         formatName = "xy"; // Latitude found.

         if (x > 20 && x < 60) {
            if (y > 0) {
               y = -y;
            }
            xyStr = y + "," + x;

         } else {
            if (x > 0) {
               x = -x;
            }
            xyStr = x + "," + y;
         }
      }

      //Create new view model object.
      const ccVM = new CoordinateVM({ view: MainMap.activeView });

      //Wait a bit to work around bug.
      setTimeout(function () { getCoordinate(ccVM, xyStr, formatName, str); }, 100);

   }).catch((error: Error) => {
      Util.errMsg('An error occurred while loading the coordinate VM module:', error);
   });
}

//Check if coordinate was entered.
function getCoordinate(ccVM: __esri.CoordinateConversionViewModel, xyStr: string, formatName: string, str: string) {

   //Formats: basemap, dd, ddm, dms, mgrs, usng, utm, and xy
   const formatOfStr = ccVM.formats.find(function (format) {
      return format.name === formatName;
   });

   ccVM.reverseConvert(xyStr, formatOfStr).then(function (pnt) {

      let fullExtent = MainMap.mapExtentFull;

      if (fullExtent.contains(pnt)) {
         let mbr = new Extent({ xmin: pnt.x, ymin: pnt.y, xmax: pnt.x, ymax: pnt.y, spatialReference: MainMap.activeView.spatialReference });

         mbr = Util_App.addMarginToMBR(mbr, true);
         MainMap.activeView.goTo(mbr, { duration: 1000 });

         //Add point graphic.
         const sym = new PictureMarkerSymbol( {
            type: "picture-marker",
            url: "Images/Flag_1.png",
            width: 18, height: 18, xoffset: 9, yoffset: 9,
         });

         const gra = new Graphic({ geometry: pnt, symbol: sym });

         GraLay.temp.add(gra);

      } else {
         SnackBar.show("Coordinate is outside the map boundary", 2);
      }

   }, function (error: Error) {
      Util.errMsg("Could not convert " + str + " to point", error);
   });
}

//Check if coordinate was entered.
export function isXY(str: string): boolean {
   const sa: string[] = str.split(",");
   if (sa.length === 2) {
      if (sa[0].IsNumeric() && sa[1].IsNumeric()) {
         return true;
      }
   }
   return false;
}
